"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { forwardRef, createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import { observable, action } from "mobx";
import TextInput, { TextInputSize, TextInputType } from "../TextInput/TextInput";
import { Search, Close } from "../../icons";
import IconButton from "../IconButton/IconButton";
import { ButtonSize } from "../Button/Button";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./SearchInput-css";
var SearchInput = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchInput, _React$Component);
  var _super = _createSuper(SearchInput);
  function SearchInput() {
    var _this;
    _classCallCheck(this, SearchInput);
    _this = _super.apply(this, arguments);
    _this.isClearButtonVisible = false;
    _this.searchInputRef = createRef();
    _this.handleClearClick = function () {
      var _a, _b, _c;
      (_a = _this.searchInputRef.current) == null ? void 0 : _a.focus();
      (_c = (_b = _this.props).onClear) == null ? void 0 : _c.call(_b);
    };
    _this.handleClearMouseDown = function (event) {
      event.preventDefault();
    };
    _this.handleClearEnter = function (node) {
      forceReflow(node);
      _this.isClearButtonVisible = true;
    };
    _this.handleClearExited = function () {
      _this.isClearButtonVisible = false;
    };
    _this.renderClearButton = function () {
      var _this$props = _this.props,
        value = _this$props.value,
        onClear = _this$props.onClear,
        theme = _this$props.theme;
      if (!onClear) return;
      if (!!value || _this.isClearButtonVisible) {
        return /* @__PURE__ */React.createElement(Transition, {
          appear: true,
          onEnter: _this.handleClearEnter,
          onExited: _this.handleClearExited,
          in: !!value,
          timeout: AnimationDuration.Medium
        }, function (status) {
          var _classNames;
          return /* @__PURE__ */React.createElement(IconButton, {
            className: classNames(styles.clear({
              visible: ["entering", "entered"].includes(status)
            }), (_classNames = {}, _defineProperty(_classNames, darkTheme, theme === "dark"), _defineProperty(_classNames, lightTheme, theme === "light"), _classNames)),
            "aria-label": "Clear search",
            size: ButtonSize.XSmall,
            icon: /* @__PURE__ */React.createElement(Close, null),
            onClick: _this.handleClearClick,
            onMouseDown: _this.handleClearMouseDown
          });
        });
      }
    };
    _this.mergeRefs = function (instance) {
      if (_this.props.innerRef != null) {
        if (typeof _this.props.innerRef === "function") {
          _this.props.innerRef(instance);
        } else {
          _this.props.innerRef.current = instance;
        }
      }
      _this.searchInputRef.current = instance;
    };
    return _this;
  }
  _createClass(SearchInput, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        label = _a.label,
        value = _a.value,
        placeholder = _a.placeholder,
        onClick = _a.onClick,
        onKeyDown = _a.onKeyDown,
        onChange = _a.onChange,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        theme = _a.theme,
        variant = _a.variant,
        className = _a.className,
        size = _a.size,
        id = _a.id,
        role = _a.role,
        onClear = _a.onClear,
        innerRef = _a.innerRef,
        endElement = _a.endElement,
        startElement = _a.startElement,
        rest = __objRest(_a, ["label", "value", "placeholder", "onClick", "onKeyDown", "onChange", "onFocus", "onBlur", "theme", "variant", "className", "size", "id", "role", "onClear", "innerRef", "endElement", "startElement"]);
      return /* @__PURE__ */React.createElement("div", {
        className: classNames(className, styles.container, "search-input")
      }, /* @__PURE__ */React.createElement(TextInput, __spreadValues({
        labelHidden: true,
        label: label,
        ref: this.mergeRefs,
        size: size,
        startElement: startElement === void 0 ? /* @__PURE__ */React.createElement(Search, null) : startElement,
        endElement: endElement === void 0 ? this.renderClearButton() : endElement,
        type: TextInputType.Search,
        onChange: onChange,
        value: value,
        placeholder: placeholder,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        theme: theme,
        variant: variant,
        id: id,
        role: role
      }, rest)));
    }
  }]);
  return SearchInput;
}(React.Component);
SearchInput.defaultProps = {
  size: TextInputSize.Medium,
  value: ""
};
__decorateClass([observable.ref], SearchInput.prototype, "isClearButtonVisible", 2);
__decorateClass([action], SearchInput.prototype, "handleClearEnter", 2);
__decorateClass([action], SearchInput.prototype, "handleClearExited", 2);
SearchInput = __decorateClass([observer], SearchInput);
export default forwardRef(function textInput(props, ref) {
  return /* @__PURE__ */React.createElement(SearchInput, __spreadValues({
    innerRef: ref
  }, props));
});